import { atomWithStorage, createJSONStorage } from "jotai/utils";
const storage = createJSONStorage(() => sessionStorage);
// Create your atoms and derivatives
export const avatarAtom = atomWithStorage("avatar", null, storage);
export const selectedPublisherIdAtom = atomWithStorage(
  "selectedPublisherId",
  null,
  storage
);
export const publisherNameAtom = atomWithStorage(
  "publisherName",
  null,
  storage
);
export const userRoleAtom = atomWithStorage("userRole", null, storage);
export const userRoleDisplayDescriptionAtom = atomWithStorage(
  "userRoleDisplayDescription",
  null,
  storage
);
export const userFullNameAtom = atomWithStorage("userFullname", null, storage);
export const keySiteAtom = atomWithStorage("keySite", null, storage);
